import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import 'devexpress-reporting/dx-richedit';
import { BaseComponent } from '../../base/base.component';
import { AuthService } from '../../../../shared/services/auth.service';
import { ajaxSetup } from '@devexpress/analytics-core/analytics-utils' 
import { DxReportDesignerComponent } from 'devexpress-reporting-angular';

@Component({
  selector: 'app-report-designer',
  encapsulation: ViewEncapsulation.None,
  templateUrl: './report-designer.component.html',
  styleUrls: [
    // '../../../../../../node_modules/jquery-ui/themes/base/all.css',
    '../../../../../../node_modules/devextreme/dist/css/dx.common.css',
    '../../../../../../node_modules/devextreme/dist/css/dx.light.css',
    '../../../../../../node_modules/devexpress-richedit/dist/dx.richedit.css',
    '../../../../../../node_modules/@devexpress/analytics-core/dist/css/dx-analytics.common.css',
    '../../../../../../node_modules/@devexpress/analytics-core/dist/css/dx-analytics.light.css',
    '../../../../../../node_modules/@devexpress/analytics-core/dist/css/dx-querybuilder.css',
    '../../../../../../node_modules/devexpress-reporting/dist/css/dx-webdocumentviewer.css',
    '../../../../../../node_modules/devexpress-reporting/dist/css/dx-reportdesigner.css',
  ],
})

export class ReportDesignerComponent extends BaseComponent implements OnInit, OnDestroy {
  
  title = 'DXReportDesignerSample';
  getDesignerModelAction = '/api/userreports/GetReportDesignerModel';
  // The report's path. The Report Designer opens it when the application starts.
  reportUrl = 'DefaultReport';
  // Backend's project URI.
  hostUrl = 'https://' + window.location.host;

  refreshInterval: any;

  // we have to manually set the auth header - don't know why but it doesn't get picked up by the http interceptor
  // https://supportcenter.devexpress.com/ticket/details/t691736/add-custom-http-headers-to-angular-client-side-report-designer-18-2-3-dx-report-designer
  constructor(private auth: AuthService) { 
    super();
    
    ajaxSetup.ajaxSettings = { headers: { Authorization: auth.getAuthorizationHeaderValue() }};
  }

  ngOnInit() {
    const self = this;
    this.refreshInterval = setInterval(() => {
      self.auth.refreshToken();
      setTimeout(() => {ajaxSetup.ajaxSettings = { headers: { Authorization: self.auth.getAuthorizationHeaderValue() }}; }, 2000);
    }, 90000);
  }

  ngOnDestroy(): void {
    if (this.refreshInterval) {
      clearInterval(this.refreshInterval);
    }
  }
}
